export default {
	strWrapper: {
		margin: [[20, 0, 40, 0]],
	},
	text: {
		color: '#9CB5D1',
	},
	contactsWrapper: {
		padding: [[20, 0]],
		textAlign: 'center',
	},
	img: {
		margin: 10,
	},
	link: {
		textDecoration: 'underline',
		color: 'white',
	},
}
